var _style, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashedOutIconLoss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 27",
    style: {
      enableBackground: "new 0 0 32 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DE0E54;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,6c-2.2,0-4,2.2-4,5c0,2.1,1.1,3.9,2.6,4.7c0.9-2.6,2.8-4.7,5.3-5.8C19.5,7.7,17.9,6,16,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31,0H1C0.4,0,0,0.4,0,1v20c0,0.6,0.4,1,1,1h13.5c-0.3-0.9-0.5-2-0.5-3H7c-0.6,0-1-0.4-1-1c0-1.1-0.9-2-2-2 c-0.6,0-1-0.4-1-1V7c0-0.6,0.4-1,1-1c1.1,0,2-0.9,2-2c0-0.6,0.4-1,1-1h18c0.6,0,1,0.4,1,1c0,1.1,0.9,2,2,2c0.6,0,1,0.4,1,1v3.4 c1.2,0.7,2.2,1.6,3,2.7V1C32,0.4,31.6,0,31,0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,11c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S28.4,11,24,11z M27,20h-6c-0.6,0-1-0.4-1-1s0.4-1,1-1h6 c0.6,0,1,0.4,1,1S27.6,20,27,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashedOutIconLoss);
export default __webpack_public_path__ + "static/media/cashed_out_icon-loss.fe312a756ac4cd508c51ec8bfd0e22c8.svg";
export { ForwardRef as ReactComponent };